import { Icon } from '../../icons/Icon';
import { companyShortName, serverSlotOf } from '../../ui/Avatar';
import { Tag } from '../../ui/controls';
import { DialogHead, Modal } from '../../ui/overlays';
import { useAppEnv, useClientState } from '../context';
import { hostOf } from '../../format';

/** Company servers + shortcuts sheet (design m-servers; the co-chip on narrow screens). */
export function ServersModal() {
  const env = useAppEnv();
  const me = useClientState((s) => s.me);
  const isAdmin = me?.role === 'owner' || me?.role === 'admin';
  const go = (fn: () => void) => () => {
    env.closeModal();
    fn();
  };
  return (
    <Modal open onClose={env.closeModal} labelledBy="msv-t" id="m-servers" size="small">
      <DialogHead titleId="msv-t" title="회사 서버" onClose={env.closeModal} />
      <div className="dlg-body">
        <p className="hint" style={{ margin: '0 0 10px 4px' }}>
          회사마다 계정·대화·알림이 따로 관리돼요.
        </p>
        {env.servers.map((s) => {
          const active = s.serverId === env.activeServerId;
          const unread = active ? 0 : (env.serverUnread[s.serverId] ?? 0);
          return (
            <button key={s.serverId} type="button" className="prow" onClick={go(() => env.switchServer(s.serverId))}>
              <span className={`srv ${serverSlotOf(s.serverId)}`} style={{ width: 42, height: 42, borderRadius: 14 }}>
                {companyShortName(s.companyName)}
              </span>
              <span className="pr-main">
                <span className="pr-name">
                  {s.companyName}
                  {active ? <Tag tone="accent">사용 중</Tag> : null}
                </span>
                <span className="pr-sub">{hostOf(s.serverUrl)}</span>
              </span>
              {unread ? <span className="badge">{unread}</span> : null}
            </button>
          );
        })}
        {env.platform.serverRegistry ? (
          <button type="button" className="prow" onClick={go(env.addServer)}>
            <span className="srv add" style={{ width: 42, height: 42, borderRadius: 14 }}>
              <Icon name="plus" />
            </span>
            <span className="pr-main">
              <span className="pr-name">회사 서버 추가</span>
              <span className="pr-sub">주소 확인 후 로그인해요</span>
            </span>
          </button>
        ) : null}
        <div className="sec-h">바로 가기</div>
        {isAdmin ? (
          <button type="button" className="prow" onClick={go(() => env.navigate('admin'))}>
            <span className="icon-btn glassy">
              <Icon name="shield" />
            </span>
            <span className="pr-main">
              <span className="pr-name">회사 관리</span>
              <span className="pr-sub">구성원·초대·보존 정책</span>
            </span>
          </button>
        ) : null}
        {env.platform.kind === 'web' ? (
          <button type="button" className="prow" onClick={go(() => env.navigate('download'))}>
            <span className="icon-btn glassy">
              <Icon name="download" />
            </span>
            <span className="pr-main">
              <span className="pr-name">PC 앱 다운로드</span>
              <span className="pr-sub">Windows · macOS · Linux</span>
            </span>
          </button>
        ) : null}
      </div>
    </Modal>
  );
}
